module.exports = __webpack_public_path__ + "static/media/1005054.efaa109f.png";